import { ExperienceContext } from "@/App/context";
import { useResponsive } from "capitalrx-components-2.0/lib/layout";
import { FC, useContext } from "react";

interface LogoProps {
  readonly onClick?: () => void;
}

export const Logo: FC<LogoProps> = ({ onClick }) => {
  const { logoDesktopUrl, logoMobileUrl } = useContext(ExperienceContext);

  const { logoComponent } = useResponsive({
    logoComponent: {
      mobile: <img width="60px" onClick={() => onClick && onClick()} src={logoMobileUrl} alt="Client Logo" />,
      desktop: <img width="230px" onClick={() => onClick && onClick()} src={logoDesktopUrl} alt="Client Logo" />,
    },
  });

  return <>{logoComponent}</>;
};
